<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g, _h;
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { onMount } from 'svelte';
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { ycSSOThirdPartyAuth } from '../../../../../js/ycapp';
import { resolveUrl } from '../../../../../js/url';
import { ycSSOSetState } from '../../../../../js/ycapp';
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: clientConfig = (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.clientConfig;
//$: handleRedirect = element?.data?.handleRedirect as boolean || false;
$: linkStore = findSourceStore($sources, 'YinzCamSignonServerLinks');
$: links = linkStore && ($linkStore === null || $linkStore === void 0 ? void 0 : $linkStore.Link);
$: baseUri = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.baseUri) || "https://www.example.com";
$: tenantId = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.tenantId) || "";
$: tenantIdParam = encodeURIComponent(tenantId);
$: redirectUri = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.redirectUri) || new URL("/modals/en/LoginWithKOREBrandedUI", document.baseURI).href;
$: redirectUriParam = encodeURIComponent(redirectUri);
//$: scope = clientConfig?.scope || "openid email profile";
//$: scopeParam = encodeURIComponent(scope);
$: register = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.register) || false;
$: nextPage = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.nextPage) || undefined;
$: nextPageExistingAccount = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.nextPageExistingAccount) || undefined;
$: endWorkflowExistingAccount = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.endWorkflowExistingAccount) || undefined;
$: endWorkflow = (_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.endWorkflow;
$: skipSetState = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.skipSetState) || false;
$: appIdOverride = ((_h = element === null || element === void 0 ? void 0 : element.data) === null || _h === void 0 ? void 0 : _h.appIdOverride) || undefined;
onMount(() => __awaiter(void 0, void 0, void 0, function* () {
    console.log("LoginWithKOREBrandedUI ON MOUNT");
    function afterConnect(existingAccount) {
        if (existingAccount && nextPageExistingAccount) {
            resolveUrl(nextPageExistingAccount).func();
        }
        else if (endWorkflow || (existingAccount && endWorkflowExistingAccount)) {
            signonManager.fireWorkflowEndEvent();
        }
        else if (nextPage) {
            resolveUrl(nextPage).func();
        }
        else if (signonManager.skipCompleteProfilePage) {
            resolveUrl(`ConnectAccounts`).func();
        }
        else {
            resolveUrl(`CompleteProfile`).func();
        }
    }
    //const codeVerifier = signonManager.generatePKCECodeVerifier();
    //const challenge = await signonManager.generatePKCEChallenge(codeVerifier);
    //window.localStorage.setItem('KOREBrandedUICodeVerifier', codeVerifier);
    //const state = 'yinzcam';
    const loginRegister = (register) ? 'register' : 'login';
    const tpaConfig = {
        url: `${baseUri}/auth/${loginRegister}?tenantid=${tenantIdParam}`,
        redirectUri,
        redirectUriParams: ['returnvisitorurl', 'successredirecturl']
    };
    ycSSOThirdPartyAuth("OAUTH", tpaConfig, (method, clientResult) => __awaiter(void 0, void 0, void 0, function* () {
        var _j, _k;
        console.log("ycSSOThirdPartyAuth callback inside OAUTH (KORE Branded UI)", method, clientResult);
        //const codeVerifier = window.localStorage.getItem('CognitoOIDCCodeVerifier');
        //window.localStorage.removeItem('CognitoOIDCCodeVerifier');
        if (clientResult === null || clientResult === void 0 ? void 0 : clientResult.error) {
            alert(clientResult.error);
            signonManager.fireWorkflowEndEvent();
            return;
        }
        if (!(clientResult === null || clientResult === void 0 ? void 0 : clientResult.redirectUri)) {
            console.warn(`ycSSOThirdPartyAuth callback for OAUTH (KORE Branded UI): missing redirectUri`);
            signonManager.fireWorkflowEndEvent();
            return;
        }
        const redirectParams = new URL(clientResult.redirectUri).searchParams;
        const tokenPayload = redirectParams.get('tokenpayload');
        if (!tokenPayload) {
            console.warn(`ycSSOThirdPartyAuth callback for OAUTH (KORE Branded UI): missing tokenpayload in redirectUri`);
            signonManager.fireWorkflowEndEvent();
            return;
        }
        let result = yield signonManager.loginWithSportsAllianceTokenPayload(tokenPayload);
        if (!result.success) {
            alert(((_k = (_j = result.data) === null || _j === void 0 ? void 0 : _j.UserMessage) === null || _k === void 0 ? void 0 : _k.Content) || 'An error occurred validating your account credentials.');
            signonManager.fireWorkflowEndEvent();
            return;
        }
        const existingAccount = result.data.AccountCreated !== 'true';
        if (!skipSetState) {
            ycSSOSetState(!existingAccount, result.data.YinzId, parseInt(result.data.ValidSpan), result.data.Ticket);
        }
        afterConnect(existingAccount);
    }));
    return () => {
        console.log('LoginWithKOREBrandedUI ON UNMOUNT');
    };
}));
</script>

<CardBase {element}>
</CardBase>
